<template>
  <div class="elevation-form pa-4 mt-4">
    <h3 class="mb-4">Share prompt list</h3>

    <v-data-table
      :loading="isLoading"
      :headers="headers"
      :items="list"
      :items-per-page="pagination.limit"
      :page.sync="pagination.page"
      no-data-text="No share prompts found"
      item-key="_id"
      hide-default-footer
    >
      <!-- Attachments -->
      <template v-slot:[`item.resource_input`]="{ item }">
        <div v-if="item.resource_input && item.resource_input.length" class="d-flex flex-wrap py-1" style="gap:6px;">
          <a
            v-for="(url, i) in item.resource_input"
            :key="i"
            :href="imageHelpers.url(url)"
            target="_blank"
            rel="noopener noreferrer"
          >
            <video
              v-if="isVideo(url)"
              :src="imageHelpers.url(url)"
              width="48"
              height="48"
              style="object-fit:cover; border-radius:4px; display:block;"
            />
            <v-img
              v-else
              :src="imageHelpers.url(url, { width: 60, height: 60 })"
              width="48"
              height="48"
              class="rounded"
              contain
            />
          </a>
        </div>
        <span v-else class="grey--text">—</span>
      </template>

      <!-- Prompt / Content -->
      <template v-slot:[`item.prompt`]="{ item }">
        <div style="max-width: 300px; white-space: pre-wrap; word-break: break-word;">{{ item.prompt || '—' }}</div>
      </template>

      <!-- Status -->
      <template v-slot:[`item.status`]="{ item }">
        <v-chip small :color="item.status === 'publish' ? 'success' : 'default'" label>
          {{ item.status }}
        </v-chip>
      </template>

      <!-- Actions -->
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn small icon @click="openEdit(item)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <div v-if="pagination.totalPage > 1" class="d-flex justify-end mt-3">
      <v-pagination v-model="pagination.page" :length="pagination.totalPage" :total-visible="7" @input="fetchList" />
    </div>

    <UpContentAdsDialog v-model="showEditDialog" :editItem="editItem" @saved="fetchList" />
  </div>
</template>

<script>
import { productApi } from '@/apis/product';
import imageHelpers from '@/helpers/image';
import UpContentAdsDialog from './UpContentAdsDialog.vue';

export default {
  name: 'SharePromptList',
  components: { UpContentAdsDialog },
  props: {
    productId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      list: [],
      pagination: {
        page: 1,
        limit: 20,
        total: 0,
        totalPage: 1,
      },
      imageHelpers,
      showEditDialog: false,
      editItem: null,
      headers: [
        { text: 'Attachments', value: 'resource_input', sortable: false, width: 160 },
        { text: 'Content', value: 'prompt', sortable: false },
        { text: 'Status', value: 'status', sortable: false, width: 110 },
        { text: '', value: 'actions', sortable: false, width: 48 },
      ],
    };
  },
  created() {
    this.fetchList();
  },
  methods: {
    openEdit(item) {
      this.editItem = item;
      this.showEditDialog = true;
    },
    isVideo(url) {
      if (!url) return false;
      const ext = url
        .split('?')[0]
        .split('.')
        .pop()
        .toLowerCase();
      return ['mp4', 'webm', 'ogg', 'mov', 'avi'].includes(ext);
    },
    async fetchList() {
      this.isLoading = true;
      try {
        const res = await productApi.sharePromtListByProduct(this.productId, {
          page: this.pagination.page,
          limit: this.pagination.limit,
        });
        if (res.data && res.data.status) {
          this.list = res.data.data || [];
          const p = res.data.pagination || {};
          this.pagination.total = p.total || 0;
          this.pagination.totalPage = p.totalPage || 1;
        }
      } catch (err) {
        console.error('SharePromptList fetchList error:', err);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
